import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { createBrowserHistory } from "history";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "rsuite/dist/rsuite.min.css";
import "react-toastify/dist/ReactToastify.css";

import LoginPage from "./pages/Login/LoginPage";
import RecuperarPassword from "./pages/Login/RecuperarPassword/RecuperarPassword";
import HomeScreen from "./pages/Home/HomeScreen";
import VentasPage from "./pages/Ventas/VentasPage";
import { ToastContainer } from "react-toastify";

export const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL,
});

function App() {
  return (

    <>

      <BrowserRouter basename={process.env.PUBLIC_URL}>

        <Switch>
          <Route path="/home" component={HomeScreen} />

          <Route path="/ventas" component={VentasPage} />


          {/* NUEVA: recuperar */}
          <Route path="/recuperar" component={RecuperarPassword} />

          {/* Login al final para que no “capture” todo */}
          <Route path="/" component={LoginPage} />
        </Switch>
      </BrowserRouter>

      <ToastContainer position="top-right" autoClose={3000} />

    </>

  );
}

export default App;
